module.exports = __webpack_public_path__ + "static/media/fz_schdviewrobot_en_US.1ce1ea07.png";